import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { EntrepreneurProspectDialogDataService } from '../../entrepreneur-prospect-dialog-data.service';
import { AlignedAccelerator } from '../aligned-accelerators.part';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, entrepreneurProspectDialogDataService: EntrepreneurProspectDialogDataService): GridSetup<AlignedAccelerator> {

	return {
		rowName: { singular: 'Accelerator', plural: 'Accelerators' },
		getRowKey: row => '' + row.accProspectAcceleratorId,
		stateKey: 'entrepreneur-prospect-dialog-aligned-accelerators-grid',
		actions: getActions(),
		buttons: getButtons(entrepreneurProspectDialogDataService),
		columns: getColumns(util),
	}
}
